// 校验ip地址
const validatorIp = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入IP地址'))
  } else {
    const reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
    if (!reg.test(value)) {
      callback(new Error('请输入正确的IP地址'))
    } else {
      callback()
    }
  }
}

// 校验端口号
const validatorPort = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入端口号'))
  } else {
    const reg = /^[0-9]*$/
    if (!reg.test(value)) {
      callback(new Error('请输入正确的端口号'))
    } else {
      callback()
    }
  }
}

// 校验网址
const validatorUrl = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入网址'))
  } else {
    const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
    if (!reg.test(value)) {
      callback(new Error('请输入正确的网址'))
    } else {
      callback()
    }
  }
}

// 校验网址或ip地址
const validatorUrlOrIp = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入网址或IP地址'))
  } else {
    const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/ || /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/g
    if (!reg.test(value)) {
      callback(new Error('请输入正确的网址或IP地址'))
    } else {
      callback()
    }
  }
}

// 校验手机号
const validatorPhone = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入手机号'))
  } else {
    const reg = /^1[3456789]\d{9}$/
    if (!reg.test(value)) {
      callback(new Error('请输入正确的手机号'))
    } else {
      callback()
    }
  }
}

// 校验身份证号
const validatorIdCard = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入身份证号'))
    return
  }

  // 基础正则：兼容15位和18位（仅初步格式校验）
  const baseReg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/
  if (!baseReg.test(value)) {
    callback(new Error('身份证号格式错误'))
    return
  }

  // 详细校验（针对18位）
  if (value.length === 18) {
    // 1. 正则分解校验（地区码+日期+顺序码+校验码）
    const detailedReg = /^([1-9]\d{5})(\d{4})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/
    if (!detailedReg.test(value)) {
      callback(new Error('身份证号格式无效'))
      return
    }

    // 提取关键信息
    const [_, areaCode, year, month, day] = detailedReg.exec(value)

    // 2. 地区码校验（示例省份代码）
    const provinceCodes = [
      '11',
      '12',
      '13',
      '14',
      '15',
      '21',
      '22',
      '23',
      '31',
      '32',
      '33',
      '34',
      '35',
      '36',
      '37',
      '41',
      '42',
      '43',
      '44',
      '45',
      '46',
      '50',
      '51',
      '52',
      '53',
      '54',
      '61',
      '62',
      '63',
      '64',
      '65'
    ]
    if (!provinceCodes.includes(areaCode.substring(0, 2))) {
      callback(new Error('地区码不合法'))
      return
    }

    // 3. 出生日期校验
    const date = new Date(`${year}-${month}-${day}`)
    if (date.getFullYear() !== parseInt(year) || date.getMonth() + 1 !== parseInt(month) || date.getDate() !== parseInt(day)) {
      callback(new Error('出生日期无效'))
      return
    }

    // 4. 校验码计算
    const weightFactors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    let sum = 0
    for (let i = 0; i < 17; i++) {
      sum += parseInt(value[i]) * weightFactors[i]
    }
    const expectedCode = checkCodes[sum % 11]
    if (value[17].toUpperCase() !== expectedCode) {
      callback(new Error('校验码错误'))
      return
    }
  }

  // 全部验证通过
  callback()
}

// 校验邮箱
const validatorEmail = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入邮箱'))
  } else {
    const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    if (!reg.test(value)) {
      callback(new Error('请输入正确的邮箱'))
    } else {
      callback()
    }
  }
}

// 校验密码强度
const validatorPassword = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入密码'))
  } else {
    const reg = /^(?=.*[a-zA-Z])(?=.*\d).{6,}$/
    if (!reg.test(value)) {
      callback(new Error('密码至少包含一个字母,且长度不少于6位'))
    } else {
      callback()
    }
  }
}

export default {
  validatorIp,
  validatorPort,
  validatorUrl,
  validatorUrlOrIp,
  validatorPhone,
  validatorIdCard,
  validatorEmail,
  validatorPassword
}

export { validatorIp, validatorPort, validatorUrl, validatorUrlOrIp, validatorPhone, validatorIdCard, validatorEmail, validatorPassword }
